module.exports = __webpack_public_path__ + "img/icon_360.736aa10e.png";